import { CollateralTypesService } from '@/modules/global-settings/loan-origination/services/loan-policies/collateral-types.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';

// Instantiate the service
const collateralTypesService = new CollateralTypesService();

// Define the state
export const state = {
  collateralTypes: [],
  collateralTypeCategories: [
    'Motor Vehicle',
    'Real Estate',
    'Cash Secured',
    'Chattels'
  ]
};
// Define the mutations
export const mutations = {
  ...make.mutations(state)
};
// Define the actions
export const actions = {
  /**
   * Fetch all collateral types
   * @async
   * @param {object} context - The store context
   * @returns {Array} - The collateral types
   * @private This will update the state with the fetched collateral types
   */
  getCollateralTypes: async ({ commit }) => {
    try {
      const { data } = await collateralTypesService.getCollateralTypes();
      commit('SET_COLLATERAL_TYPES', data);
      return data;
    } catch (error) {
      Logger.error('getting collateral type', error);
      throw error;
    }
  },
  /**
   * Creates a new collateral type
   * @async
   * @param {object} context - The store context
   * @param {object} payload - The collateral type payload
   * @returns {object} - The created collateral type
   * @private This will refetch the collateral types after creating a new collateral type
   */
  createCollateralType: async ({ dispatch }, payload) => {
    try {
      const { data } = await collateralTypesService.createCollateralType(
        payload
      );
      dispatch('getCollateralTypes');
      return data;
    } catch (error) {
      Logger.error('creating collateral type', error);
      throw error;
    }
  },
  /**
   * Update a single collateral type
   * @async
   * @param {object} context - The store context
   * @param {object} payload - The collateral type payload
   * @returns {void}
   * @private This will refetch the collateral types after updating a collateral type
   */
  updateCollateralType: async ({ dispatch }, payload) => {
    try {
      await collateralTypesService.updateCollateralType(payload.id, payload);
      dispatch('getCollateralTypes');
    } catch (error) {
      Logger.error('updating collateral type', error);
      throw error;
    }
  },
  /**
   * Delete a single collateral type
   * @async
   * @param {object} context - The store context
   * @param {object} id - The collateral type id
   * @returns {void}
   * @private This will refetch the collateral types after deleting a collateral type
   */
  deleteCollateralType: async ({ dispatch }, id) => {
    try {
      await collateralTypesService.deleteCollateralType(id);
      dispatch('getCollateralTypes');
    } catch (error) {
      Logger.error('getting collateral type', error);
      throw error;
    }
  }
};

// Define the getters
export const getters = make.getters(state);
